module.exports = __webpack_public_path__ + "094158220f53c836c984751a69f61042.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-82.cur
// module id = 480
// module chunks = 0